module.exports = __webpack_public_path__ + "static/media/0.92ca245e.svg";